import React, { useState } from 'react';
import { publisherData } from '../data/mockData';
import { Mail, MessageSquare, Send } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';

export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    toast.success('Mensaje enviado', {
      description: 'Gracias por contactarnos. Te responderemos pronto.',
    });
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contacto" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              Contacto
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-amber-800 mx-auto mb-4"></div>
            <p className="text-xl text-gray-600 mt-6">
              Estamos para acompañarte en tu camino
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Form */}
            <Card className="shadow-xl border-gray-200">
              <CardContent className="p-8">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">Envíanos un mensaje</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      Nombre
                    </label>
                    <Input
                      id="name"
                      name="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Tu nombre"
                      required
                      className="w-full border-gray-300 focus:border-amber-600 focus:ring-amber-600"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Email
                    </label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="tu@email.com"
                      required
                      className="w-full border-gray-300 focus:border-amber-600 focus:ring-amber-600"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Mensaje
                    </label>
                    <Textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="¿Cómo podemos ayudarte?"
                      required
                      rows={5}
                      className="w-full border-gray-300 focus:border-amber-600 focus:ring-amber-600 resize-none"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-amber-600 to-amber-800 hover:from-amber-700 hover:to-amber-900 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                  >
                    <Send size={20} />
                    <span>Enviar mensaje</span>
                  </button>
                </form>
              </CardContent>
            </Card>

            {/* Contact Info */}
            <div className="space-y-6">
              <Card className="shadow-lg border-gray-200 hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="bg-amber-100 p-3 rounded-full">
                      <Mail className="text-amber-700" size={24} />
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-2">Email</h4>
                      <a 
                        href={`mailto:${publisherData.email}`}
                        className="text-amber-700 hover:text-amber-800 transition-colors"
                      >
                        {publisherData.email}
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="shadow-lg border-gray-200 hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="bg-green-100 p-3 rounded-full">
                      <MessageSquare className="text-green-700" size={24} />
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-2">WhatsApp</h4>
                      <p className="text-gray-600 mb-2">Contáctanos directamente</p>
                      <a 
                        href={publisherData.social.whatsapp || "https://wa.me/+5492604123456"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-green-700 hover:text-green-800 font-medium transition-colors"
                      >
                        Iniciar chat
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-amber-50 to-white border-amber-200 shadow-lg">
                <CardContent className="p-8">
                  <p className="text-gray-700 text-lg leading-relaxed italic">
                    "Cada pregunta es un paso hacia el crecimiento. No dudes en escribirnos."
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};